import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useCardListStatus } from '@/hooks'

export default function CardHistoryDetail() {
    const { t } = useTranslation()
    const { getCardListStatus } = useCardListStatus()
    const location = useLocation()
    const record = location.state?.record as CardRecordItem & { avatarSvg: string } | undefined
    return (
        <PageLayout>
            <Header leftChildren={<Back />} />
            <div className='px-6 py-6'>
                <div className='flex flex-col justify-center items-center space-y-2'>
                    <div className='w-10 h-10 bg-[#EAEEF6] rounded-full flex items-center justify-center'>
                        <img className="w-4" src={record?.avatarSvg} />
                    </div>
                    <div className='text-base font-600 text-black'>{record?.merch_name}</div>
                    <div className='text-8 font-600 text-black'>{record?.business_change} USD</div>
                    <div className='text-xs text-black'>{getCardListStatus(record?.txn_type || '')}</div>
                </div>
                <div className='px-4.5 py-4 rounded-2xl bg-white border-[0.5px] border-[#000000]/10 border-solid space-y-3 mt-3'>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>{t('付款账户')}</div>
                        <div className='text-xs text-[#000000]'>USDT/USDC/USD1</div>
                    </div>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>{t('金额')}</div>
                        <div className='text-xs text-[#000000]'>{record?.business_change} USD</div>
                    </div>
                </div>
                <div className='px-4.5 py-4 rounded-2xl bg-white border-[0.5px] border-[#000000]/10 border-solid space-y-3 mt-3'>
                    <div className='text-xs font-600 text-[#000000]/70'>{t('交易详情')}</div>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>{t('日期')}</div>
                        <div className='text-xs text-[#000000]'>{record?.transaction_at_string}</div>
                    </div>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>{t('卡号')}</div>
                        <div className='text-xs text-[#000000]'>{record?.card_no}</div>
                    </div>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>{t('商户名称')}</div>
                        <div className='text-xs text-[#000000]'>{record?.merch_name}</div>
                    </div>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>{t('商户地区')}</div>
                        <div className='text-xs text-[#000000]'>{record?.merch_ctry}</div>
                    </div>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>MCC</div>
                        <div className='text-xs text-[#000000]'>{record?.mcc}</div>
                    </div>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>{t('交易ID')}</div>
                        <div className='text-xs text-[#000000]'>{record?.auth_txn_id}</div>
                    </div>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>{t('授权费')}</div>
                        <div className='text-xs text-[#000000]'>{record?.business_auth_fee} USD</div>
                    </div>
                    <div className='justify-between items-center flex'>
                        <div className='text-xs text-[#000000]/70'>{t('手续费')}</div>
                        <div className='text-xs text-[#000000]'>{record?.business_service_fee} USD</div>
                    </div>
                </div>

            </div>
        </PageLayout>
    )
}